import { render, staticRenderFns } from "./ReportsHistoryDialog.vue?vue&type=template&id=0dfa2006&"
import script from "./ReportsHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./ReportsHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports